import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import { useEffect, useState } from 'react';
import ContextAPI from '../services/context.api.service';
import useAlert from './Alert/useAlert';

export const ContextSelect = ({onContextChange}) => {
    const {showErrorAlert} = useAlert();
    const [state, setState] = useState({
        contexts: [],
        context: '',
    });

    const changeState = (partialState) => setState(currentState => ({...currentState, ...partialState}));
    const startLoading = () => changeState({loading: true});
    const stopLoading = () => changeState({loading: false});

    useEffect(() => {onContextChange(state.context)}, [state.context]);

    useEffect(() => {
        startLoading();
        ContextAPI
            .getContext()
            .then(result => changeState({contexts: result.items, context: result.items[0]}))
            .catch(err => showErrorAlert(err.response.data.message))
            .finally(() => stopLoading())
    }, []);

    return (
        <TextField
            name="context"
            select
            size="small"
            fullWidth
            label="Business context"
            value={state.context}
            onChange={event => changeState({context: event.target.value})}
            required
        >
            {state.contexts.map(context => (
                <MenuItem key={context.id} value={context}>
                    {context.name}
                </MenuItem>
            ))}
        </TextField>);
}
